import { render } from "./MatchSummary.vue?vue&type=template&id=21b843de"
import script from "./MatchSummary.vue?vue&type=script&lang=js"
export * from "./MatchSummary.vue?vue&type=script&lang=js"

import "./MatchSummary.vue?vue&type=style&index=0&id=21b843de&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__